import WindowsReplacementGeneralInformation from './WindowsReplacementGeneralInformation';

export default WindowsReplacementGeneralInformation;